module.exports = __webpack_public_path__ + "img/1_1.04b3e926.jpg";